import get from 'lodash.get';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectSelectedShipmentIds = (state) => get(state, 'selectedShipmentIds', emptyArray);

export const selectCount = (state) => get(selectSelectedShipmentIds(state), 'length');
